import React from 'react';

import styles from './styles.css';

const Conclusion = (props) => (
	<section className="conclusion">
		<article>
			<p>
				Cinematography and real life have always been two parallel universes. 
				The analysis of the most popular names used in each of these worlds has once again confirmed this statement.	
			</p>
			<p>
				No doubt, the impact of a daily life on a process of choosing names for TV & movie characters is huge.
				As well as famous heroes from the screen forced parents to call their babies Luke or Daenerys.
			</p>
			<p>
				And of couse, there are сommon trends in naming such as using top ~10 names much more often than others. 
				However, the devil is in the details. Writers & cinema directors try to be less repetetive and more creative especially if we talk about male characters.
				At the same time, they usually don't want to be too exotic in naming to save the connection between their film / series and target audience.
			</p>
		</article>
	</section>
);

export default Conclusion; 